﻿(function() {
    'use strict';

    angular.module('app.config').constant('configConstants', {
        enums: {
            authorise: {
                authorised: 0,
                loginRequired: 1,
                notAuthorised: 2,
                logged: 3
            },
            permissionCheckType: {
                atLeastOne: 0,
                combinationRequired: 1
            },
            userRoles: {
                operator: 'OPE',
                limitedCarrier: 'LIC'
            },
            pages: {
                gateIn: 'GTI',
                gateOut: 'GTO'
            }
        }
    });
    
})();
